import { useMachine, useService } from '@xstate/react';
import React, { createContext, useContext, useCallback } from 'react';
import { notificationsMachine } from './notificationsMachine';
import { ReactComponent as Cross } from '@jetshop/ui/svg/Cross.svg';
export const NotificationsContext = createContext(undefined);
export function NotificationsProvider({ children }) {
    const [state, send] = useMachine(notificationsMachine);
    return (React.createElement(NotificationsContext.Provider, { value: [state, send] }, children));
}
export function Notifications(props) {
    const [current] = useContext(NotificationsContext);
    const { context, matches } = current;
    return (React.createElement(React.Fragment, null, matches('active') && (React.createElement("div", Object.assign({}, props, { "data-flight-notifications": "" }), context.notifications.map(notification => (React.createElement(Notification, { actor: notification.ref, key: notification.id })))))));
}
export function Notification({ actor }) {
    const [{ context, toStrings }, send] = useService(actor);
    const { content, type } = context;
    const dismiss = useCallback(() => {
        send('REMOVE');
    }, [send]);
    return (React.createElement("div", { "data-flight-notification": toStrings(), "data-flight-notification-type": type },
        React.createElement("div", { "data-flight-notification-inner": "" },
            React.createElement("button", { onClick: dismiss, "data-flight-notification-dismiss": "" },
                React.createElement(Cross, { "aria-label": "Close" })),
            content)));
}
//# sourceMappingURL=Notifications.js.map